export default __webpack_public_path__ + "static/media/map.b03c20b2.svg";